import { atom, getDefaultStore } from 'jotai';

export type MagicFlowPendingDeepLink = { templateId: string };

// No `debugLabel`: `ipc.ts` loads this module in suites whose jotai mock makes
// `atom(null)` return null, and setting a property on it would crash them.
/**
 * A Magic Flow deep link received on desktop and not yet opened. Held in memory
 * so a link that arrives while signed out opens after sign-in; a restart drops it.
 */
export const magicFlowPendingDeepLinkAtom = atom<MagicFlowPendingDeepLink | null>(null);

/** Drops a pending link on sign-out so the next account never opens it. */
export const clearMagicFlowPendingDeepLink = () => {
  getDefaultStore().set(magicFlowPendingDeepLinkAtom, null);
};
